export const CITY_STORES_ACTIONS = {
  REQUESTED: 'city/stores/requested',
  SUCCEEDED: 'city/stores/succeeded',
  FAILED: 'stores/failed',
};

export interface StoresRequested {
  type: string;
  payload: { cityId: string };
}

export const storesRequested = (cityId: any): StoresRequested => ({
  payload: { cityId },
  type: CITY_STORES_ACTIONS.REQUESTED,
});

export interface StoresSucceeded {
  type: string;
  payload: { stores: any[]; city: any };
}

export const storesSucceeded = (stores: any[], city: any): StoresSucceeded => ({
  type: CITY_STORES_ACTIONS.SUCCEEDED,
  payload: { stores, city },
});

export interface StoresFailed {
  type: string;
  error: string;
}

export const storesFailed = (error: string): StoresFailed => ({
  error,
  type: CITY_STORES_ACTIONS.FAILED,
});

export type StoresAction = StoresRequested | StoresSucceeded | StoresFailed;



// WEBPACK FOOTER //
// ./src/scenes/CityStores/services/actions.ts